/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { SyntheticEvent, useState } from 'react';
import UnavailableChipMetadata from '../../../../shared/components/UnavailableChipMetadata';
import { ProductApiModel } from '../../../../shared/models/ProductModel';
import ProductDetailModal from './ProductDetailModal';
import styles from './productNameCell.module.scss';

export default function ProductNameCell({ model }: { model: ProductApiModel }) {
  const [showModal, setShowModal] = useState(false);
  const onModalCancel = () => setShowModal(false);
  const onMoreDetailsClick = (e: SyntheticEvent) => {
    e.preventDefault();
    setShowModal(true);
  };

  return (
    <>
      <div className={`d-flex flex-column ${styles.productNameContainer}`}>
        {model.retired && <UnavailableChipMetadata />}
        <p
          className={`mb-0 ${styles.name} ${
            model.retired ? styles.gray400 : ''
          }`}
          dangerouslySetInnerHTML={{ __html: model.name }}
        />
        <div
          className={`d-flex justify-content-between align-items-center flex-sm-row-reverse flex-row overflow-hidden text-nowrap ${
            model.retired ? styles.gray400 : ''
          }`}
        >
          <div className={styles.sku}>SKU: {model.sku}</div>
          <a
            href="#"
            className={`${styles.link} ${
              model.retired ? styles.gray400 : ''
            } accent-link`}
            onClick={onMoreDetailsClick}
          >
            More Details
          </a>
        </div>
      </div>
      {showModal && (
        <ProductDetailModal onCancel={onModalCancel} product={model} />
      )}
    </>
  );
}
